/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */
// remove on cart page start

/**** preorder atc and default atc button ***/

// remove on cart page end
// default product add to cart start

console.log("Custom js running");

$(".accordion-item:first").addClass("open");

$(".image_with_video .video_main_icon").click(function () {
  $(".page-gold-main-image").show();
  $(".image_with_video .video-section").hide();
  $(".image_with_video .video-section video").trigger("pause");
  $(this).parents(".page-gold-main-image").hide();
  $(this).parents(".image_with_video").find(".video-section").show();
  $(this)
    .parents(".image_with_video")
    .find(".video-section video")
    .trigger("play");
});

$(window).on("load resize", function (e) {
  var screenwidth = $(window).outerWidth();
  var containerwidth = $(".wrapper--full").width();
  var calculated = screenwidth - containerwidth;
  var finalval = calculated / 2;
  $(".image_video_content .image_video_text").css(
    "padding-left",
    finalval + "px"
  );
});

// product add to cart with addon product start
$("body").on(
  "click",
  ".btn.product__submit__add_custom.add_cart_btn",
  function (e) {
    e.preventDefault();
    return 0;
    var getId = $(this).attr("data-id");
    console.log(getId);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        quantity: 1,
        id: getId,
      },
      dataType: "json",
      success: function (data) {
        console.log("custom add to cart clicked");
        $(
          ".product__submit__item.orignal_button_tag .btn.product__submit__add.add_cart_btn"
        );//.trigger("click");
      },
    });
  }
);
// product add to cart with addon product end
// product product quik view start
// product quick view end
function mobileOnlySlider() {
  $(".testi_mobile_slider").slick({
    autoplay: false,
    speed: 2000,
    adaptiveHeight: true,
    centerMode: false,
    autoplaySpeed: 2000,
    arrows: true,
    dots: true,
    prevArrow:
      '<div class="slick-prev"><svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.19531 6.1875L6.9375 0.40625C7.17188 0.171875 7.39323 0.171875 7.60156 0.40625L8.38281 1.14844C8.59115 1.38281 8.59115 1.60417 8.38281 1.8125L3.73438 6.5L8.38281 11.1875C8.59115 11.3958 8.59115 11.6172 8.38281 11.8516L7.60156 12.5938C7.39323 12.8281 7.17188 12.8281 6.9375 12.5938L1.19531 6.8125C0.986979 6.60417 0.986979 6.39583 1.19531 6.1875Z" fill="#696969"/></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.80469 6.1875L2.0625 0.40625C1.82812 0.171875 1.60677 0.171875 1.39844 0.40625L0.617188 1.14844C0.408854 1.38281 0.408854 1.60417 0.617188 1.8125L5.26562 6.5L0.617188 11.1875C0.408854 11.3958 0.408854 11.6172 0.617188 11.8516L1.39844 12.5938C1.60677 12.8281 1.82812 12.8281 2.0625 12.5938L7.80469 6.8125C8.01302 6.60417 8.01302 6.39583 7.80469 6.1875Z" fill="#696969"/></svg> </div>',
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          arrows: false,
          centerMode: false,
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  });
}
function mobileOnlyBlog() {
  $(".blog-listing-outer .blog-listing").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    adaptiveHeight: true,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
}
$(document).ready(function () {
  if ($(window).width() > 1024) {
    $(".scrolling-header .search-main-main").remove();
    $(".search-main-main").insertAfter(".inasert_data_here");
    $(".search-main-main").show();
  }
  $("a.main_search_icon ,a.main_search_icon.navlink").click(function (e) {
    e.preventDefault();

    $(".search-main-main").slideToggle();
  });

  setTimeout(function () {
    $(".cf-widget-video-slider .cf-slider-arrow").insertAfter(
      ".cf-widget-items-wrapper"
    );
  }, 500);
  $(".main_faq_page .accordion h4.accordion__title").eq(0).trigger("click");

  setTimeout(function () {
    $(".triiger-2").trigger("click");
  }, 500);

  //   $(".collection__sidebar__slider ").removeClass("expanding");
  //   $(".collection__sidebar__slider ").removeClass("expanded");

  if (window.innerWidth < 768) {
    setTimeout(function () {
      mobileOnlySlider();
    }, 500);
    setTimeout(function () {
      mobileOnlyBlog();
    }, 800);
    $("body").on(
      "click",
      ".accordion.mobile_only .accordion-item",
      function () {
        $(this)
          .prevAll(".accordion.mobile_only .accordion-item")
          .removeClass("open");
        $(this).toggleClass("open");
        $(this)
          .nextAll(".accordion.mobile_only .accordion-item")
          .removeClass("open");
      }
    );
  }

  $(window).resize(function (e) {
    if (window.innerWidth < 768) {
      if (!$(".testi_mobile_slider").hasClass("slick-initialized")) {
        mobileOnlySlider();
      }
    } else {
      if ($(".testi_mobile_slider").hasClass("slick-initialized")) {
        $(".testi_mobile_slider").slick("unslick");
      }
    }
    if ($(window).width() > 1024) {
      $(".scrolling-header .search-main-main").remove();
      $(".search-main-main").insertAfter(".inasert_data_here");
      $(".search-main-main").show();
    }
    if ($(window).width() < 1025) {
      $(".scrolling-header .search-main-main").remove();
      $(".search-main-main").insertAfter(".header__desktop");
      $(".search-main-main").hide();
    }
  });

  $(window).resize(function () {
    var width = $(window).width();
    if (width > "748") {
      $(".footer__block__title")
        .parents(".links-footer")
        .find("ul.footer__quicklinks")
        .show();
    } else {
      //       $('.footer__block__title"').parents(".links-footer").find("ul.footer__quicklinks").hide();
    }
  });
  $("body").on("click", ".footer__block__title", function (e) {
    e.preventDefault();
    var width = $(window).width();
    if (width <= "748") {
      $(".footer__block__title")
        .not(this)
        .parents(".links-footer")
        .find("ul.footer__quicklinks")
        .hide();
      $(".footer__block__title")
        .not(this)
        .parents(".links-footer")
        .removeClass("active");
      $(".footer__block__title").not(this).removeClass("active");
      $(this)
        .parents(".links-footer")
        .find("ul.footer__quicklinks")
        .slideToggle();
      $(this).parents(".links-footer").toggleClass("active");
      $(this).toggleClass("active");
    }
  });

  var size_li = $(".cstm_collection_item .cstm_product_item").length;
  var x = 12;
  $(".cstm_collection_item .cstm_product_item").slice(0, x).show();
  $("body").on("click", "#loadMore", function (e) {
    e.preventDefault();
    //x= (x+12 <= size_li) ? x+12 : size_li;
    if (x < size_li) {
      var next = x + 12;
    } else {
      var next = size_li;
    }

    $(".cstm_collection_item .cstm_product_item:hidden").slice(0, 12).show();
    var data_count = $(".cstm_product_item.product-item:visible").length;
    $("span.show_count").text(data_count);
    x = next;

    if (x >= size_li) {
      $("#loadMore").fadeOut("slow");
    }
  });

  var $buttonPlus = $(".increase-btn");
  var $buttonMin = $(".decrease-btn");
  var $quantity = $(".quantity");

  /*For plus and minus buttons*/
  $buttonPlus.click(function () {
    $quantity.val(parseInt($quantity.val()) + 1).trigger("button");
  });

  $buttonMin.click(function () {
    $quantity.val(Math.max(parseInt($quantity.val()) - 1, 0)).trigger("button");
  });

  $("form .cstm_size span.radio__button input").change(function () {
    var size = $(this).val();
    $(this)
      .parents("fieldset.radio__fieldset")
      .find(".cstm_size_text")
      .html(size);
    var text = "";
    $(this)
      .parents(".product-form")
      .find(".cstm_size span.radio__button input")
      .each(function () {
        if ($(this).is(":checked")) {
          text += $(this).attr("data-value") + " / ";
          // alert(text)
        }
      });
    var newname = text.slice(0, -2).trim();
    console.log(newname);

    var main_sku = $(this)
      .parents(".product-form")
      .find(".product__form__select option[var-title='" + newname + "']")
      .attr("data-sku");
    var main_qty = $(this)
      .parents(".product-form")
      .find(".product__form__select option[var-title='" + newname + "']")
      .attr("data-quantity");
    var main_val = $(this)
      .parents(".product-form")
      .find(".product__form__select option[var-title='" + newname + "']")
      .val();
    var main_price = $(this)
      .parents(".product-form")
      .find(".product__form__select option[var-title='" + newname + "']")
      .attr("data-price");

    var continue_selling = $(this)
      .parents(".product-form")
      .find(".product__form__select option[var-title='" + newname + "']")
      .attr("data-continue-selling");
    //$(".product__price span").text(main_price);
    $(".product__price > span").text(main_price);
    $(".product__submit__add.add_cart_btn").attr("data-id", main_val);
    // Update the hidden input field so the variant ID is sent correctly to the cart
    $("input.sel-var-id").val(main_val);
    
    // Update the URL with the new variant ID
    if (window.history && typeof window.history.replaceState === 'function') {
      const location = window.location.href;
      if (location.includes('/product')) {
        const url = new window.URL(location);
        const params = url.searchParams;
        params.set('variant', main_val);
        url.search = params.toString();
        const urlString = url.toString();
        window.history.replaceState({path: urlString}, '', urlString);
      }
    }
    
    if (main_sku != "" && typeof main_sku !== "undefined") {
      $(".product_sku ").html(
        " <p><span>SKU: </span> <span class='append_data'>" +
          main_sku +
          "</span><p>"
      );
      $(".product_sku").show();
    } else {
      $(".product_sku").hide();
    }
    if (typeof main_qty !== "undefined") {
      console.log("Selling : ", continue_selling);
      if (main_qty > 0 || continue_selling == "continue") {
        $(".product__submit__add span").text("Add To Cart");
        $(".product__submit__add").removeAttr("disabled");
        $(".product__submit__add").addClass("add_cart_btn");
        $(".form__wrapper").removeClass("variant--unavailable");
      } else {
        $(".product__submit__add span").text("Sold Out");
        $(".product__submit__add").attr("disabled", "disabled");
        $(".product__submit__add").removeClass("add_cart_btn");
        $(".form__wrapper").addClass("variant--unavailable");
      }
    } else {
      $(".product__submit__add span").text("Unavailable");
      $(".product__submit__add").attr("disabled", "disabled");
      $(".product__submit__add").removeClass("add_cart_btn");
      $(".form__wrapper").addClass("variant--unavailable");
    }
  });
  $("form .cstm_size span.radio__button input").eq(0).trigger("change");
  $(".tabs-nav a:first-child").addClass("active");
  $(".tabcontent").hide();
  $(".tabcontent:first").show();
  $(".tabs-nav a").click(function () {
    $(".tabs-nav a").removeClass("active");
    $(this).addClass("active");
    $(".tabcontent").hide();
    var activeTab = $(this).attr("href");

    $(activeTab).show();
    return false;
  });

  $(".cstm_quant_cart").on("button", ".quantity", function () {
    var price = +$(".price").data("price");
    var quantity = +$(this).val();
    $("#total").text("$" + price * quantity);
  });

  $(".cstm_size.product__selectors .selector-wrapper").each(function () {
    var size = $(this).find("span.radio__button input:checked").val();
    // alert(size)
    $(this).find(".cstm_size_text").html(size);
  });

  if ($(window).width() < 992) {
    $(".collection__sidebar__slider").removeClass("expanded");
  }
  var main_qty = $(".product-form .product__form__select option:selected").attr(
    "data-quantity"
  );
  var continue_selling = $(
    ".product-form .product__form__select option:selected"
  ).attr("data-continue-selling");
  if (typeof main_qty !== "undefined") {
    console.log("Selling : ", continue_selling);
    if (main_qty > 0 || continue_selling == "continue") {
      $(".product__submit__add span").text("Add To Cart");
      $(".product__submit__add").removeAttr("disabled");
      $(".product__submit__add").addClass("add_cart_btn");
      $(".form__wrapper").removeClass("variant--unavailable");
    } else {
      $(".product__submit__add span").text("Sold Out");
      $(".product__submit__add").attr("disabled", "disabled");
      $(".product__submit__add").removeClass("add_cart_btn");
      $(".form__wrapper").addClass("variant--unavailable");
    }
  } else {
    $(".product__submit__add span").text("Unavailable");
    $(".product__submit__add").attr("disabled", "disabled");
    $(".product__submit__add").removeClass("add_cart_btn");
    $(".form__wrapper").addClass("variant--unavailable");
  }
});

$(window).resize(function () {
  if ($(window).width() < 992) {
    $(".collection__sidebar__slider").removeClass("expanded");
  } else {
    $(".collection__sidebar__slider").addClass("expanded");
  }
});

$(".cros_btn").click(function () {
  $(".collection__sidebar__slider").removeClass("expanded");
});

// $("body").on("click", ".cros_btn", function(e) {
//     e.preventDefault();

//      if($(".collection__sidebar__slider").hasClass("expanded")){
//        $(".collection__sidebar__slider").removeClass("expanding");
//        $(".collection__sidebar__slider").removeClass("expanded");
//        $(".cstm_collection_item").find(".popout__toggle").attr("aria-expanded","false");
//      }else{
//          $(".collection__sidebar__slider").addClass("expanding");
//        $(".collection__sidebar__slider").addClass("expanded");
//        $(".cstm_collection_item").find(".popout__toggle").attr("aria-expanded","true");

//      }

// });
// if($(".stamped-badge-caption").length > 0){
//   setTimeout(function() {
//     var hhStamp = $(".stamped-badge-caption").html();

//     var retArray = hhStamp.split("<span");
//     var value = retArray[0];
//     var newValue = "("+value+")<span class='hide-val'  "+retArray[1];
//     $(".stamped-badge-caption").html(newValue);
//   }, 2000);

// }
// const myInterval = setInterval(reviews, 1000);

// function reviews() {
//   $(".cstm_product_item").each(function(){
//     var data_review = $(this).find("span.stamped-badge-caption").attr("data-reviews");
//     $(this).find("span.stamped-badge-caption").text("("+data_review+")");
//   });
// }

// function myStopFunction() {
//   clearInterval(myInterval);
// }

// $(document).on("click",".sidebar__item",function() {
//    setTimeout(function() {
//     location.reload();
//    },1000);

// });

$(window).on("load resize", function (e) {
  var height = jQuery(".image_with_video .inner").outerHeight();
  jQuery(".slide-image.image_main_slider").css({
    height: "calc(100% - " + height + "px)",
  });
  jQuery(".main_video_slider").css({ height: "calc(100% - " + height + "px)" });

  var screenwidth = $(window).outerWidth();
  var containerwidth = $(".wrapper--full").width();
  var calculated = screenwidth - containerwidth;
  var finalval = calculated / 2;
  $(".banner-content .brick__block__text").css("padding-left", finalval + "px");
});

$(document).on("click", ".popout-list__item", function () {
  setTimeout(function () {
    $("#loadMore").trigger("click");
  }, 2000);
});

var lastScrollTop = 0;
var css =
  ".Header--fixed{position: fixed; top: 0px; left: 0px; width: 100%; transition: transform .15s ease; overflow: visible} .scrolling-header.scroll-up{overflow: visible;} .scrolling-header.scroll-down{ transform: translateY(-160px); overflow: hidden;}";
$("body").append("<style>" + css + "</style>");

$(window).scroll(function (t) {
  var e = $(this).scrollTop(),
    i = $(".theme__header");
  e <= 20
    ? (i.removeClass("Header--fixed"), i.removeClass("Scroll__up_header"))
    : e > lastScrollTop
    ? (i.removeClass("Header--fixed"), i.addClass("Scroll__up_header"))
    : (i.addClass("Header--fixed"), i.removeClass("Scroll__up_header")),
    (lastScrollTop = e);
});
$(".scrolling-header .menu__item").mouseover(function () {
  $(".menu__item").removeClass("is-visible");
  $(".header__dropdown").removeClass("is-visible");
  $(this).addClass("is-visible");
  $(this).find(".header__dropdown").addClass("is-visible");
});
$(".scrolling-header .menu__item").mouseleave(function () {
  $(".menu__item").removeClass("is-visible");
  $(".header__dropdown").removeClass("is-visible");
});

$(
  ".product_var_here .cstm_size.product__selectors span.radio__button input"
).change(function () {
  var dataval = $(this).val();
  $(
    ".product__form .cstm_size.product__selectors  span.radio__button input[value='" +
      dataval +
      "']"
  ).trigger("click");
});

$(window).on("load resize", function (e) {
  var anno_height = jQuery("div#shopify-section-announcement").outerHeight();
  var head_height = jQuery(".header__desktop__upper").outerHeight();
  var num = 1;
  var total_anno_head = anno_height + head_height + num;
  // alert(total_anno_head);
  jQuery(".top_nav_wrapper ul.menu li.menu-link .megamenu_wrapper").css(
    "top",
    total_anno_head
  );
});

$(".menu-link").hover(function () {
  get_div = $(this).children(".megamenu_wrapper").length;
  if (get_div == 1) {
    $(".megamenu_wrapper").hide();
    $(this).parent().find(".megamenu_wrapper").show();
  } else {
    $(".megamenu_wrapper").hide();
  }
});

$(document).on("mouseleave", ".megamenu_wrapper", function () {
  $(this).hide();
});

$(".menu__item").hover(function () {
  $(".megamenu_wrapper").hide();
});
$(".search__popdown__upper input").click(function () {
  $(".megamenu_wrapper").hide();
});
$(".cart__icon__content").click(function () {
  $(".megamenu_wrapper").hide();
});

$(".select-popout__list li").click(function () {
  var url = window.location.href;
  var parts = url.split("=");
  var last_part = parts[parts.length - 1];
  $(".product__form__select").val(last_part);
  var check_availble = $(".product__form__select option:selected").attr(
    "data-available"
  );
  if (check_availble == "yes") {
    $("a.btn.klaviyo-bis-trigger").hide();
  } else {
    $("a.btn.klaviyo-bis-trigger").show();
  }
});
$(document).ready(function () {
  var divCheckingInterval = setInterval(function () {
    // Find it with a selector
    if (
      document.querySelector("#address_country") != null &&
      document.querySelector("#address_country").length < 1
    ) {
      if (document.querySelector("#address_country").length == "237") {
        var select = document.querySelector("#address_country");
        select.value = "US";

        /* since programatically changes won't fire the change event,
       we need to do it ourselves */
        var event = document.createEvent("HTMLEvents");
        event.initEvent("change", true, false);
        select.dispatchEvent(event);
        clearInterval(divCheckingInterval);
        // Do something
      }
    }
  }, 500);

  $(".menu__item.parent").on("mouseover", function () {
    $(this)
      .find(".main_drop_desktop_menu .megamnu_image_inner")
      .each(function () {
        var data_src = $(this).find(".image_wrapper img").attr("data-src");
        $(this).find(".image_wrapper img").attr("src", data_src);
      });
  });
});

$(".cart-bar__submit").on("click", function () {
  var productid = $("form .product__submit__add.add_cart_btn").attr("data-id");
  var data_qty = $("input.quantity__input").val();
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: productid,
      quantity: data_qty,
    },
    dataType: "json",
    success: function (productid) {
      jQuery.ajax({
        type: "GET",
        url: "/cart",
        dataType: "html",
        success: function (cart) {
          window.location.href = window.location.origin + "/cart";
        },
      });
    },
  });
});

$(".product__submit__add.add_cart_btn").click(function (e) {
  e.preventDefault();

  var $btn = $(this);
  if ($btn.data("clicked")) return;
  return 0;

  $btn.data("clicked", true);

  var productid = $("input.sel-var-id").val() || $btn.attr("data-id");
  var data_qty = $("input.quantity__input").val();

  console.log("Processing");
  document.querySelector("#add_to_cart_btn_txt").innerHTML = "Adding...";

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: productid,
      quantity: data_qty,
    },
    dataType: "json",
    success: function (productid) {
      console.log(productid);

      jQuery.ajax({
        type: "GET",
        url: "/cart",
        dataType: "html",
        success: function (cart) {
          // Redirect to the cart page
          window.location.href = window.location.origin + "/cart";
        },
      });
    },
    error: function () {
      // Optional: Re-enable the button on error
      $btn.data("clicked", false);
      document.querySelector("#add_to_cart_btn_txt").innerHTML = "Add to Cart";
      alert("There was an error adding the item to your cart.");
    },
  });
});

//console.clear();
// quick add cart quantity box start
var QtyInput = (function () {
  var $qtyInputs = $(".qty-input");

  if (!$qtyInputs.length) {
    return;
  }

  var $inputs = $qtyInputs.find(".product-qty");
  var $countBtn = $qtyInputs.find(".qty-count");
  var qtyMin = parseInt($inputs.attr("min"));
  var qtyMax = parseInt($inputs.attr("max"));

  $inputs.change(function () {
    var $this = $(this);
    var $minusBtn = $this.siblings(".qty-count--minus");
    var $addBtn = $this.siblings(".qty-count--add");
    var qty = parseInt($this.val());

    if (isNaN(qty) || qty <= qtyMin) {
      $this.val(qtyMin);
      $minusBtn.attr("disabled", true);
    } else {
      $minusBtn.attr("disabled", false);

      if (qty >= qtyMax) {
        $this.val(qtyMax);
        $addBtn.attr("disabled", true);
      } else {
        $this.val(qty);
        $addBtn.attr("disabled", false);
      }
    }
  });

  $countBtn.click(function () {
    var operator = this.dataset.action;
    var $this = $(this);
    var $input = $this.siblings(".product-qty");
    var qty = parseInt($input.val());

    if (operator == "add") {
      qty += 1;
      if (qty >= qtyMin + 1) {
        $this.siblings(".qty-count--minus").attr("disabled", false);
      }

      if (qty >= qtyMax) {
        $this.attr("disabled", true);
      }
    } else {
      qty = qty <= qtyMin ? qtyMin : (qty -= 1);

      if (qty == qtyMin) {
        $this.attr("disabled", true);
      }

      if (qty < qtyMax) {
        $this.siblings(".qty-count--add").attr("disabled", false);
      }
    }

    $input.val(qty);
  });
})();

// quick add cart quantity box end
// accordion product ad to cart and price change start

$("body").on(
  "change",
  "select.custom_prodcut_variant_add_to_cart",
  function () {
    var getVarid = $(this).find("option:selected").attr("data-id");
    var getVarprice = $(this).find("option:selected").attr("data-price");
    console.log(getVarid + "==" + getVarprice);
    $(this)
      .parents(".produts_list_accordion")
      .find(".product_custom_add_to_cart button")
      .text("Add" + getVarprice);
  }
);

$("body").on("click", ".product_custom_add_to_cart", function () {
  var getVarid = $(this)
    .parents(".produts_list_accordion")
    .find("option:selected")
    .attr("data-id");
  // alert(getVarid)
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: getVarid,
      quantity: 1,
    },
    dataType: "json",
    success: function (productid) {
      jQuery.ajax({
        type: "GET",
        url: "/cart",
        dataType: "html",
        success: function (cart) {
          window.location.href = window.location.origin + "/cart";
        },
      });
    },
  });
});
// accordion product ad to cart and price change end
// document.querySelectorAll(".accordion-item").forEach((item) => {
//   item.querySelector(".accordion-item-header").addEventListener("click", () => {
//     item.classList.toggle("open");
//   });
// });
// cart remove button start

document.addEventListener("click", function (e) {
  if (e.target && e.target.id === "cart-minus-btn") {
    const btn = e.target;
    // Disable the button
    btn.disabled = true;

    // Re-enable after 500ms
    setTimeout(() => {
      btn.disabled = false;
    }, 500);
  }
});

$(document).on(
  "click",
  ".cart-item__remove.custom_product_remve_cart",
  function (e) {
    console.log("Remove Clicked");
    e.preventDefault();
    e.stopPropagation();

    var $button = $(this);

    if ($button.data("processing")) {
      return;
    }

    minusBtn.disabled = true;

    $button.data("processing", true);

    var getId = $button.attr("var-id");

    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: getId,
        quantity: 0,
      },
      dataType: "json",
      success: function () {
        window.location.href = window.location.origin + "/cart";
      },
      error: function () {
        $button.data("processing", false);
        alert("Failed to remove item. Please try again.");
      },
    });
  }
);

// cart remove buttn end
$("body").on(
  "click",
  "section.cusom_best_tool_greasing.mobile_only .tabs-collections ul.tabs.tabs--center li",
  function () {
    var getText = $(this).text();
    console.log(getText);
    $(
      "section.cusom_best_tool_greasing.mobile_only .custom_buttton_section .grid__btn-wrapper.kko.text-center.mobile_only a"
    ).text("Shop" + getText);
  }
);
var getText1 = $(
  "section.cusom_best_tool_greasing.mobile_only .tabs-collections ul.tabs li.current span"
).text();
$(
  "section.cusom_best_tool_greasing.mobile_only .custom_buttton_section .grid__btn-wrapper.kko.text-center.mobile_only a"
).text("Shop " + getText1);
if ($(window).width() < 768) {
  setTimeout(function () {
    //  alert()
    var gteCarttext = $(
      ".cart-bar__submit.product__submit button.btn.product__submit__add.add_cart_btn span"
    ).text();
    if (gteCarttext == "Add To Cart") {
      $(
        ".cart-bar__submit.product__submit button.btn.product__submit__add.add_cart_btn span"
      ).text("Add");
    }
  }, 500);
}

//$('.custom_tab_collection_slider button.flickity-button.flickity-prev-next-button.next').trigger('click');
